module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/name/suffix.js
// module id = 1531
// module chunks = 1